<template>  
  <div> 
    
    <div class="progress mt-2"> 
   
      <div class="progress-bar p-b-impact-critical" v-b-tooltip.hover 
        :title="`${$ml.get('criticalImpact')} ${parseFloat(((critical.qnt / total) *100).toFixed(1))}% - ${critical.qnt} ${$ml.get('reports')}`" 
        :style="`width: ${parseFloat((critical.qnt / total) *100)}%`"> </div>

      <div class="progress-bar p-b-impact-high" v-b-tooltip.hover 
        :title="`${$ml.get('highImpact')} ${parseFloat(((high.qnt / total) *100).toFixed(1))}% - ${high.qnt} ${$ml.get('reports')}`" 
        :style="`width: ${parseFloat((high.qnt / total) *100)}%`"></div>

      <div class="progress-bar p-b-impact-medium" v-b-tooltip.hover 
        :title="`${$ml.get('mediumImpact')} ${parseFloat(((medium.qnt / total) *100).toFixed(1))}% - ${medium.qnt} ${$ml.get('reports')}`" 
        :style="`width: ${parseFloat((medium.qnt / total) *100)}%`"></div>

      <div class="progress-bar p-b-impact-low" v-b-tooltip.hover 
        :title="`${$ml.get('lowImpact')} ${parseFloat(((low.qnt / total) *100).toFixed(1))}% - ${low.qnt} ${$ml.get('reports')}`" 
        :style="`width: ${parseFloat((low.qnt / total) *100)}%`"></div>

      <div class="progress-bar p-b-impact-informative" v-b-tooltip.hover 
        :title="`${$ml.get('notImpact')} ${parseFloat(((informative.qnt / total) *100).toFixed(1))}% - ${informative.qnt} ${$ml.get('reports')}`" 
        :style="`width: ${parseFloat((informative.qnt / total) *100)}%`"></div> 
    </div> 
    <label>{{targets.scope_description}}</label>
  </div> 
</template>
<script> 

export default {
  name: "progressBar", 
  props: ["targets"],
  components: {},
  data() {
    return { 
      total: 0,
      critical:{
        qnt: 0
      },
      high:{
        qnt: 0
      },
      medium:{
        qnt: 0
      },
      low:{
        qnt: 0
      },
      informative:{
        qnt: 0
      }
    };
  }, 
  mounted() { 
    
    this.total = this.targets.quantity;

    this.targets.statistics.map((item) => { 
      if(item.severity == 'critical'){  
        this.critical.qnt = item.quantity; 
      }

      if(item.severity == 'high'){  
        this.high.qnt = item.quantity;
      }

      if(item.severity == 'medium'){  
        this.medium.qnt = item.quantity;
      }

      if(item.severity == 'low'){  
        this.low.qnt = item.quantity;
      }

      if(item.severity == '' || item.severity == 'none' || item.severity == 'informative'){  
        this.informative.qnt += item.quantity;
      } 
    })
  },
};
</script>
